import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useDailyLogin } from '@/hooks/useDailyLogin';
import { AuraLandingPage } from '@/components/landing/AuraLandingPage';
import { AuraAgentScreen } from '@/components/agent/AuraAgentScreen';
import { PageLoaderSkeleton } from '@/components/ui/skeletons';

export default function Index() {
  const navigate = useNavigate();
  const { user, profile, loading: authLoading } = useAuth();
  
  // Initialize daily login bonus
  useDailyLogin();

  const [showOnboarding, setShowOnboarding] = useState(false);

  // Check if user needs onboarding
  useEffect(() => {
    if (user && profile) {
      const hasSeenOnboarding = localStorage.getItem(`aura_onboarding_${user.id}`);
      if (!hasSeenOnboarding) {
        setShowOnboarding(true);
      }
    }
  }, [user, profile]);

  const handleOnboardingComplete = () => {
    if (user) {
      localStorage.setItem(`aura_onboarding_${user.id}`, 'true');
    }
    setShowOnboarding(false);
  };

  // Show landing page if not logged in
  if (!authLoading && !user) {
    return <AuraLandingPage onGetStarted={() => navigate('/auth')} />;
  }

  // Loading state with skeleton
  if (authLoading) {
    return <PageLoaderSkeleton />;
  }

  // Single screen agent experience
  return (
    <AuraAgentScreen
      onShowOnboarding={showOnboarding}
      onOnboardingComplete={handleOnboardingComplete}
    />
  );
}
